import React, { useState } from 'react';
import Panel from '@prisjakt/ui-panel';
import T from '@prisjakt/ui-translate';
import Placeholder from '../placeholder';
import PriceInformation from '../../price-information';
import { getSortedPrices } from '../utils/sorting';
import PriceListHeader from './price-list-header';
import PriceListFooter from './price-list-footer';
import PriceListBody from './price-list-body';
import { IPriceListPanelProps } from './types';
import { getListPrices, getCommonListProps, getListLimits } from './utils';
import { SortOptionEnum } from '../offer-list-sorting/types';
import MissingShop from '../../missing-shop';
import { PriceDisplay, PriceDisplayEnum } from 'src/areas/product/types';

function splitPriceList(
  currentSorting: SortOptionEnum,
  priceDisplay: PriceDisplay
): boolean {
  switch (currentSorting) {
    default:
    case SortOptionEnum.PRICE:
      return priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING;
    case SortOptionEnum.RECOMMENDED:
    case SortOptionEnum.PRICEANDSTOCKSTATUS:
      return true;
  }
}

const PriceListPanel: React.FC<IPriceListPanelProps> = props => {
  const { me, variantGroups, conditions } = props;
  const [showMorePrices, setShowMorePrices] = useState(false);
  const [showMoreUnfeaturedPrices, setShowUnfeaturedMorePrices] = useState(
    false
  );

  const sortedPrices = getSortedPrices(
    props.priceDisplay,
    props.currentSorting,
    props.prices
  );

  const isGroupedList = splitPriceList(
    props.currentSorting,
    props.priceDisplay
  );

  const prices = getListPrices(
    sortedPrices,
    isGroupedList,
    props.currentSorting,
    props.priceDisplay
  );
  const commonListProps = getCommonListProps(props);
  const listLimits = getListLimits(prices, isGroupedList);

  return (
    <Panel>
      <PriceListHeader
        conditions={conditions}
        variantGroups={variantGroups}
        categoryId={props.category?.id}
      />
      {props.storeStatistics && (
        <PriceInformation storeStatistics={props.storeStatistics} />
      )}
      {me?.analyticsAccess?.stores && <MissingShop />}

      {sortedPrices && sortedPrices.length > 0 ? (
        <>
          <PriceListBody
            sortedPrices={prices.mainList}
            showMorePrices={showMorePrices}
            numberOfVisiblePrices={listLimits.mainListLimit}
            splitList={isGroupedList}
            {...commonListProps}
          />
          <PriceListFooter
            showProductInformationTexts={props.showProductInformationTexts}
            sortedPrices={prices.mainList}
            showMorePrices={showMorePrices}
            numberOfVisiblePrices={listLimits.mainListLimit}
            setShowMorePrices={setShowMorePrices}
          />
          {isGroupedList &&
            prices.secondaryList &&
            prices.secondaryList.length > 0 && (
              <>
                <h3>
                  <T domain="product" product="splitlist-other.title">
                    splitlist-other.title
                  </T>
                </h3>
                <PriceListBody
                  sortedPrices={prices.secondaryList}
                  showMorePrices={showMoreUnfeaturedPrices}
                  numberOfVisiblePrices={listLimits.secondaryListLimit}
                  splitList={isGroupedList}
                  {...commonListProps}
                />
                <PriceListFooter
                  showProductInformationTexts={
                    props.showProductInformationTexts
                  }
                  sortedPrices={prices.secondaryList}
                  showMorePrices={showMoreUnfeaturedPrices}
                  numberOfVisiblePrices={listLimits.secondaryListLimit}
                  setShowMorePrices={setShowUnfeaturedMorePrices}
                />
              </>
            )}
        </>
      ) : (
        <Placeholder category={props.category} />
      )}
    </Panel>
  );
};

export default PriceListPanel;
